import { fork } from 'redux-saga/effects'
import * as watchers from './event-group-details-watchers'

export default [
  fork(watchers.watchDraftEventGroupSave),
  fork(watchers.watchEntitiesEventGroupSuccess),
  fork(watchers.watchDraftEventGroupCancel)
]



/** WEBPACK FOOTER **
 ** ./src/sagas/event-group-details/index.js
 **/